export var deepCopy = function (inObject) {
    var value;
    var key;
    if (typeof inObject !== "object" || inObject === null) {
        return inObject;
    }
    var outObject = Array.isArray(inObject) ? [] : {};
    // eslint-disable-next-line guard-for-in
    for (key in inObject) {
        value = inObject[key];
        outObject[key] = deepCopy(value);
    }
    return outObject;
};
//# sourceMappingURL=deep-copy.js.map